(ns bp-libs.design-system.components.title-details
  (:require [bp-libs.design-system.components.buttons :refer [Button]]
            [bp-libs.design-system.components.thumb :refer [thumb]]
            [clojure.string :as string]))

(defn- label-value [label value]
  [:div {:class ["flex flex-col"
                 "space-y-2"]}
   [:div {:class ["text-gray-400 text-2xl font-medium"]}
    label]
   [:div {:class ["text-white text-2xl font-medium"]}
    value]])

(defn- rating-component
  [rating-url]
  [:span {:class ["inline-flex items-center"
                  "pr-2"]
          :style {:height "24px"}}
   [thumb {:container {:width "24px" :height "24px"}
           :image-url rating-url}]])

(defn title-details
  {:storybook {:description       {:name         "Description"
                                   :type         {:name "string"}
                                   :defaultValue "Quais as consequências mais sombrias de se tornar um dos homens mais poderosos do mundo? Como tensões ideológicas podem afetar uma empresa?"
                                   :control      {:type "text"}}
               :tab-index         {:name         "tab-index, use -1 to disable"
                                   :type         {:type "number"}
                                   :defaultValue 10
                                   :control      {:type "number"}}
               :rating            {:name "Rating"
                                   :type {:name "object"}
                                   :defaultValue {:url "https://res.cloudinary.com/hvzbb2hdx/image/upload/ratings/A16/f0bee5e1-d871-11ed-841d-ff884ebfdaef"
                                                  :advisory ["Violência" "Temas sensíveis"]}}
               :title                   {:name         "Banner title"
                                         :type         {:name "string"}
                                         :defaultValue "Some title here"
                                         :control       {:type "text"}}
               :duration                {:name         "Duration"
                                         :type         {:name "string"}
                                         :defaultValue "2hrs 16 min"
                                         :control       {:type "text"}}
               :release-year            {:name         "Release year"
                                         :type         {:name "string"}
                                         :defaultValue "2018"
                                         :control       {:type "text"}}
               :teachers                {:name         "Teachers"
                                         :type         {:name "array"}
                                         :defaultValue ["Laura Branner" "Victor Sales"]
                                         :control      {:type "array"}}
               :directors               {:name         "Directors"
                                         :type         {:name "array"}
                                         :defaultValue ["Lucas Ferrugem" "Henrique Zingano"]
                                         :control      {:type "array"}}
               :cast                    {:name         "Cast"
                                         :type         {:name "array"}
                                         :defaultValue ["ThePrimeagen" "Matthew Perry"]
                                         :control      {:type "array"}}
               :background-thumb-url    {:name         "Background Thumb Url"
                                         :type         {:name "string"}
                                         :defaultValue "https://picsum.photos/800/800"
                                         :control      {:type "text"}}
               :logo-url                {:name         "Banner logo url"
                                         :type         {:name "string"}
                                         :defaultValue "https://picsum.photos/300/340"
                                         :control      {:type "text"}}}}
  [{:keys [react-ref on-key-down scroll-ref
           tab-index
           description rating release-year duration
           on-back
           logo-url title background-thumb-url
           directors teachers cast]}]
  [:div {:class ["h-screen w-screen"
                 "z-50"
                 "bg-surface-primary-3"
                 "absolute"]
         :ref react-ref}
   [:div {:class ["w-full relative xl:text-base text-lg h-full select-none"]}
    [:div {:class ["absolute top-0 w-full bg-black z-0 h-[60vh]"]}
     [thumb {:container {:width "100%" :height "100%"}
             :image-filter?         true
             :full-image?           true
             :square-border?        true
             :image-filter-position "left"
             :image-url             background-thumb-url}]]

    [:div {:ref scroll-ref
           :class ["absolute top-0 left-0 flex flex-col z-10"
                   "h-full"
                   "overflow-y-auto hide-scroll-bar"]}
     [:div {:class ["py-20 px-36"
                    "space-y-8"
                    "flex flex-col grow"
                    "bg-gradient-to-b from-transparent via-black via-30% to-black "]}
      [:div {:class ["flex flex-col"
                     "h-[20vh]"]}
       (if logo-url
         [thumb {:container           {:width "100%" :height "10vh"}
                 :image-fit           "fill"
                 :class               "transition-opacity ease-in duration-500 opacity-100"
                 :image-url           logo-url}]
         [:h1 {:class ["text-white text-5xl/[3.4rem] font-semibold"]} title])]
      [:div {:class ["grow"
                     "after:h-24 after:bg-black after:block"]}
       [:div {:class ["flex w-full"
                      "space-x-16"]}
        [:div {:class ["space-y-4"
                       "w-1/2"]}
         ^{:key "sinopse"}
         [label-value "Sinopse" description]]
        [:div {:class ["flex"
                       "space-x-4"
                       "w-1/2"]}
         [:div {:class ["space-y-8"
                        "w-1/2"]}
          ^{:key "rating"}
          [label-value "Classificação indicativa"
           [:span {:class ["space-x-2"]}
            [rating-component (:url rating)]
            (string/join ", " (:advisory rating))]]
          ^{:key "release-year"}
          [label-value "Ano de lançamento" release-year]
          (when (seq duration)
            ^{:key "duration"}
            [label-value "Duração" duration])]

         [:div {:class ["space-y-8"
                        "w-1/2"]}
          (when (seq teachers)
            ^{:key "teachers"}
            [label-value "Professores" (map (fn [t] [:p t]) teachers)])
          (when (seq directors)
            ^{:key "directors"}
            [label-value "Diretores" (map (fn [d] [:p d]) directors)])
          (when (seq cast)
            ^{:key "cast"}
            [label-value "Elenco" (map (fn [c] [:p c]) cast)])]]]]
      [:div {:class ["fixed bottom-20"]}
       [Button {:color         "black"
                :react-ref     react-ref
                :on-key-down   on-key-down
                :extra-classes ["py-3.5 px-7 outline-none text-lg"]
                :tab-index     tab-index
                :on-click      on-back}
        [:span {:class "inline-flex space-x-2 items-center"}
         "Voltar"]]]]]]])
